'use client'

import { ITabsItem } from '@partment/types'
import { usePathname } from 'next/navigation'
import { useEffect, useState } from 'react'
import { stripRolePrefix } from '..'

export const useMobileBottomNavBar = (tabs: ITabsItem[]) => {
  const pathname = usePathname()
  const [value, setValue] = useState<string | null>(null)
  useEffect(() => {
    const normalizedPath = stripRolePrefix(pathname)

    let matchedHref = ''
    tabs.map((tab) => {
      const normalizedHref = stripRolePrefix(tab.href)
      if (
        normalizedPath === normalizedHref ||
        normalizedPath.startsWith(normalizedHref + '/')
      ) {
        if (normalizedHref.length > matchedHref.length) {
          matchedHref = tab.href
        }
      }
    })

    if (matchedHref) {
      setValue(matchedHref)
    }
  }, [pathname, tabs])

  return {
    value,
    setValue,
  }
}
